/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import customNoRowsOverlay from './customNoRowsOverlay.jsx';
export const EdwTable = (props) => {
    const icons = {
        sortAscending: '<i className=""></i>', //ag-icon ag-icon-asc
        sortDescending: '<i className=""></i>',     //ag-icon ag-icon-desc          
    }
    return (
        <div className="ag-theme-alpine" id="blind" style={{ height: props.height, width: 'auto' }}>
            <AgGridReact tooltipShowDelay={0}
                columnDefs={props.columndef}
                rowData={props.rowData}
                icons={icons}
                onCellClicked={props.onCellClicked}
                getRowHeight={props.getRowHeight}
                onGridReady={props.onGridReady}
                rowBuffer={props.rowBuffer}
                domLayout={props.domLayout}
                frameworkComponents={{
                    customNoRowsOverlay: customNoRowsOverlay,
                }}
                noRowsOverlayComponent={'customNoRowsOverlay'}
                noRowsOverlayComponentParams={{
                    noRowsMessage: "No data found",
                }}
            >
            </AgGridReact>
        </div>
    )
};